























































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list/index'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
@Component({
  components: {}
})
export default class PageSelect extends AbpBase {
  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []

  columns: any[] = [
    {
      title: '微页面名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '最后修改时间',
      slot: 'lastUpdateTime',
      align: 'center'
    },
    {
      title: '是否设成首页',
      slot: 'isHomePage',
      align: 'center'
    }
  ]

  async mounted() {}
  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.getPageList()
  }

  async getPageList() {
    await MallConfig.getMallDiyList(this.pageSize, this.pageIndex, true).then(
      res => {
        this.total = res.data.totalCount
        this.data = res.data.items
      }
    )
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.getPageList()
  }
  currentChange(currentRow, oldCurrentRow) {
    this.$emit('on-row-selected', currentRow)
    this.modal1 = false
  }

  cancel() {
    this.$emit('on-row-selected', null)
    this.modal1 = false
  }
}
